import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container,  Grid, Button, Box } from '@mui/material'
import {GrantDetailService} from '../shared/service';
import {Check, X} from "react-feather";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CustomDataGrid from '../../../customUtil/DataGrid';
import {ISACTIVE} from '../../../constants';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const GrantDetails = () => {
        const [list, setList] = useState([]);
        const [result, setResult] = useState({});
        const [options, setOptions] = useState([]);      
        const [countries, setCountries] = useState([]);
        const initialValue = {countries: '', languages: '', active: '', emailsValidated: ''};
        const filterParams = [];
        const savedFilters = JSON.parse(localStorage.getItem("Gt"));
        const [selected, setSelected] = useState(savedFilters ? savedFilters : initialValue);
        const [searchParam, setSearchParam] = useState(JSON.parse(localStorage.getItem("GtSearch"))? JSON.parse(localStorage.getItem("GtSearch")) : '');  
        const [rowList,  setRowList] = useState([]);


        const [tempRow, setTempRow] = useState([]);

        const columns = [
            {
                field: 'grantName', headerName: 'Name', width: 230,
                renderCell: (params) => (
                    <Link  style={{textDecoration: 'none'}} component={RouterLink} to={'/gas/grant/' + params.row.id} >
                        {params.value}
                    </Link>
                )
            },
            {
                field: 'countryName', headerName: 'Country', width: 200
            },
            {
                field: 'languageName', headerName: 'Language', width: 200
            },
            {
                field: 'active', headerName: 'Active', width: 150, renderCell: (params) => (
                    <>{params.value ? <Check color='green'/> : <X/>}</>
                )
            },
            {
                field: 'emailsValidated', headerName: 'Emails Validated', width: 200, renderCell: (params) => (
                    <>{params.value ? <Check color='green'/> : <X/>}</>
                )
            }
        ]
     
        useEffect(() => {
            GrantDetailService.getById('options')
            .then((response) => {
                setOptions(response.data);
                setCountries(response.data.countries)
            })
            GrantDetailService.search()
                .then((response) => {
                    setResult(response.data.results);
                    setTempRow(response.data.results);
                    if(savedFilters){
                        setSelected(JSON.parse(localStorage.getItem("Gt")));
                          } 
                });
        }, []);


        const detectChange = (e) => {
            setSearchParam(e.target.value);
           // searchKey(e.target.value);
             }

        const filterList = () => {   
            selected.countries !== '' && filterParams.push({'countryName' : selected.countries})
             selected.languages !== '' && filterParams.push({'languageName' : selected.languages})
             selected.emailsValidated !== '' && filterParams.push({'emailsValidated' : selected.emailsValidated})
            selected.active !== '' && filterParams.push({'active' : selected.active})
         
             let tempList = tempRow;
            filterParams.forEach(parent => {
                const filterBUffer = [] ;    
               tempList.forEach(el => {             
                 Object.entries(el).map(key => {
                    let parentKey = Object.keys(parent)
                    let parentValue = Object.values(parent)
                    if(key[0] === parentKey.toString()){
                        if(key[1] === parentValue[0]){
                            filterBUffer.push(el);
                        }
                    }
                 },[])               
                 })
                 tempList = filterBUffer;              
            });
                    setList(tempList)  
                    setRowList(tempList);                
        }
        
        const searchKey = (e) => {
            let tempList = [];
            const filterBUffer = [] ; 
            rowList.forEach((filteredList) => {   
        if(filteredList.grantName?.toLowerCase().includes(e.toLowerCase())){
        filterBUffer.push(filteredList)
        }else if(filteredList.countryName?.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }else if(filteredList.languageName?.toLowerCase().includes(e.toLowerCase())){
         filterBUffer.push(filteredList)
        }        
        tempList = filterBUffer
      })    
      setList(tempList);
          }
   
        useEffect(() => {
            filterList();
            localStorage.setItem('Gt', JSON.stringify(selected));
            localStorage.setItem('code', 'Gt'); 
           },[selected]);

           useEffect(() => {
            localStorage.setItem('GtSearch', JSON.stringify(searchParam));
            if(searchParam !== ''){
              searchKey(searchParam)
            }
          },[rowList, searchParam]);  

        useEffect(() => {
            if (result.results) {
                setList(result.results);
            }else{
                setList([]);
            }
        }, [result]);

        const clearFilter = () => {
            setSelected(initialValue);
            localStorage.removeItem('Gt');
           }

        const handleChange = (param, e) => {
            setSelected({
                ...selected, 
                [param]: e.target.value})
          }

          const handleSubmit = (event) => {
            event.preventDefault();
            filterList();
          };

        return (
            <Container>
                <header>
                    <h1>Grants</h1>
                </header>
               
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" component={RouterLink} to='/gas/grant/new'>Create New</Button>
                        </Grid>
                        <Grid item xs={12}>
                        

      <form onSubmit={handleSubmit}>
              <Grid container spacing={4}>
                  <Grid item xs={9}>
                  <FormControl sx={{ m: 1, minWidth: 200 }}>
                        <Autocomplete
                           value={selected.countries}
                           onChange={(event, newValue) => {
                             setSelected({ ...selected, countries: newValue == null ? "" : newValue});
                           }}  
                           options={countries.map((option) => option.name)}
                           style={{ width: 300 }}
                           renderInput={(params) => (
                             <TextField {...params} label="Country" variant="outlined" />
                           )}
                         />                      
                         </FormControl>                       
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Language</InputLabel>
                           <Select value={selected.languages} onChange={(e) => handleChange('languages', e)}
                          endAdornment={
                            selected.languages !== '' ? (
                                <IconButton sx={{visibility: selected.languages !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 languages: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {options.languages?.map((el) => (
                      <MenuItem    value={el.name}>
                      {el.name}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Active</InputLabel>
                           <Select value={selected.active} onChange={(e) => handleChange('active', e)}
                          endAdornment={
                            selected.active !== '' ? (
                                <IconButton sx={{visibility: selected.active !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 active: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {ISACTIVE?.map((el) => (
                      <MenuItem    value={el.value}>
                      {el.key}
                    </MenuItem>
                               ))}      
                            
                           </Select>
                         </FormControl>
                         <FormControl sx={{ m: 1, minWidth: 150 }}>
                           <InputLabel>Emails Validated</InputLabel>
                           <Select value={selected.emailsValidated} onChange={(e) => handleChange('emailsValidated', e)}
                          endAdornment={
                            selected.emailsValidated !== '' ? (
                                <IconButton sx={{visibility: selected.emailsValidated !== ''? "visible": "hidden"}} 
                                onClick={() => {setSelected({
                                 ...selected, 
                                 emailsValidated: ''})}}><ClearIcon/></IconButton>
                            ) : (
                            false
                            )
                            }
                     >
                               {ISACTIVE?.map((el) => (
                      <MenuItem    value={el.value}>
                      {el.key}
                    </MenuItem>
                               ))} 
                           </Select>
                         </FormControl>
                         <Button style={{marginTop: "10px"}} variant="contained" color="primary" onClick={clearFilter}>Clear Filter</Button>
                         </Grid>
                      
                                </Grid>
                                     </form>
      </Grid>
     
                        {/* <Grid item xs={12}>

                            <Controller
                                name="searchTerm"
                                control={methods.control}
                                fullWidth
                                onChange={(v) => onSearchTermChanged(v)}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (<TextField fullWidth
                                                 onBlur={onBlur}
                                                 onChange={(e) => {
                                                     onChange(e.target.value);
                                                     onSearchTermChanged(e.target.value)
                                                 }}
                                                 label="Search: Type country, grant name"
                                                 startAdornment={
                                                     <InputAdornment position="start">
                                                         <SearchIcon/>
                                                     </InputAdornment>
                                                 }
                                />)}
                                label="Search: Type country, grant name, language"
                                color="primary"
                            />


                        </Grid> */}
                        <Grid item xs={12}>
                        <Box
                            component="form"
                            sx={{'& > :not(style)': { m: 1, width: '25ch' }}}
                           // style={{float: "right"}}
                            noValidate
                            autoComplete="on"
                          >   
                          <TextField type="text" defaultValue={searchParam} label="Search" variant="standard" onChange={detectChange}  />
                         </Box>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                showQuickFilter={true}
                                />
                        </Grid>
                    </Grid>
                   
            </Container>
        );
    }
;

export default GrantDetails;
